export const BODY_THEME_YELLOW_CANON = (props) => {

	let svgWidth = props.svgWidth || "100%";
	let svgHeight = props.svgHeight || "100%";
	let svgViewBox = props.svgViewBox || "0 0 720 504";
	let svgPreserveAspectRatio = props.svgPreserveAspectRatio || "none";
	let svgStyle = props.svgStyle || {background:"transparent"};


	return(
		<div>
		<svg xmlns="http://www.w3.org/2000/svg"
			width={svgWidth}
			height={svgHeight}
			viewBox={svgViewBox}
			preserveAspectRatio={svgPreserveAspectRatio}
			style={svgStyle}
		>

        
      


    {/*Two*/}
    <polygon 
        fill="rgb(220,220,220)" 
        points="60.552,329.4 92.127,396 655.779,396 655.779,275.4 642.933,250.745 608.1,230.634 436.5,209.563 86.8,185.109 76.176,203.256 76.193,275.4 60.568,275.4 60.552,329.4"
    />
    {/*One*/}
    <path 
        fill="rgb(230,230,230)" 
        d="M86.8,185.109l349.7,24.454l171.6,21.07l34.833,20.111v15.957 H612.34c-15.189-20.885-39.639-34.682-67.349-35.165c-23.848-0.417-45.626,9.108-61.376,24.737 c-26.417-13.027-57.538-16.255-83.05-17.921l-147.315-9.01c-18.387-1.125-5.965,30.828-22.414,18.791 c-13.847-10.339-30.925-16.596-49.456-16.92c-32.641-0.569-61.421,17.41-76.258,44.186H76.176v-72.144L86.8,185.109L86.8,185.109z"
    />
    {/*Three*/}
    <polygon 
        fill="rgb(255,255,255)" 
        points="92.127,396 642.933,396 642.933,298.921 227.025,275.4 60.568,275.4 60.552,329.4 92.127,396"
    />
    {/*Three Front Bumper*/}
    <polygon 
        fill="rgb(230,230,230)" 
        points="655.779,379.3 655.779,298.921 642.933,298.921 642.933,379.3 655.779,379.3 	"
    />
    {/*Vent Background*/}
    <path 
        fill="rgb(255,255,255)" 
        d="M629.269,348.577l18.681,4.628l2.489-0.004 c1.779-0.004,3.422-0.325,3.422-2.821l-0.001-29.823c0-1.021-0.404-1.261-0.984-1.281l-21.414-0.759 c-4.165-0.147-5.582,1.514-5.583,5.976l-0.001,17.603C625.877,344.809,626.697,347.94,629.269,348.577L629.269,348.577z"
    />
    {/*Vent*/}
    <path 
        fill="rgb(190,190,190)" 
        d="M648.527,353.204l-9.437-5.126c-1.72-0.934-2.519-2.618-2.52-4.77 l-0.005-11.837c0-2.773,0.814-4.013,2.066-4.716l13.386-7.511l-20.558-0.729c-4.165-0.147-5.582,1.514-5.583,5.976l-0.001,17.603 c0,2.714,0.82,5.846,3.392,6.482l18.681,4.628L648.527,353.204L648.527,353.204z"
    />
    {/*Vent Shadow*/}
    <path 
        fill="rgb(130,130,130)" 
        d="M628.042,324.644c-0.001-2.038,1.858-2.907,3.285-3.068 l20.691-2.33l-20.558-0.729c-4.165-0.147-5.582,1.514-5.583,5.976l-0.001,17.603c0,2.714,0.82,5.846,3.392,6.482 c-0.957-1.553-1.22-4.483-1.221-5.71L628.042,324.644L628.042,324.644z"
    />
    {/*Vent Highlight*/}
    <path 
        fill="rgb(255,255,255)" 
        d="M632.043,348.424l12.192,3.385l-7.12-4.247 c-6.029-3.596-8.149-15.236-8.107-8.605C629.051,345.587,629.347,347.676,632.043,348.424L632.043,348.424z"
    />
    {/*Rear Bumper*/}
    <polygon 
        fill="rgb(230,230,230)" 
        points="76.176,329.4 92.127,396 179.855,396 179.855,329.4 76.176,329.4"
    />
    {/*Rear Bumper Highlight*/}
    <polygon 
        fill="rgb(230,230,230)" 
        points="76.176,285.279 60.552,285.279 60.568,275.4 76.176,275.4 76.176,285.279"
    />
    {/*Rear Bumper Shadow*/}
    <polygon 
        fill="rgb(210,210,210)" 
        points="60.552,329.4 76.176,329.4 92.127,396 60.552,329.4"
    />
    {/*Rocker*/}
    <path 
        fill="rgb(190,190,190)" 
        d="M642.933,379.3V396H92.127l-0.001-0.002L92.127,396l0,0l-4-16.7 C283.727,379.3,447.309,379.3,642.933,379.3L642.933,379.3z"
    />
    {/*Inset Highlight*/}
    <path 
        fill="rgb(230,230,230)" 
        d="M459.484,351.795c-4.402-10.491-8.731-21.947-22.984-22.57	L179.855,318.02v41.717l280.313-0.024C461.342,359.712,461.205,355.898,459.484,351.795L459.484,351.795z"
    />
    {/*Inset Shadow*/}
    <path 
        fill="rgb(150,150,150)" 
        d="M459.484,351.795c-4.402-10.491-8.731-21.947-22.984-22.57	L179.855,318.02v12.312l251.604,10.985c10.855,0.475,22.532,9.438,26.881,16.582c0.765,1.256,1.308,1.813,1.828,1.813 C461.342,359.712,461.205,355.898,459.484,351.795L459.484,351.795z"
    /> 
     {/*Front Lip Highlight*/}
    <polygon 
        fill="rgb(190,190,190)" 
        points="543.528,365.473 655.779,365.473 655.779,364.026 642.933,362.38 633.41,364.026 543.528,364.026 543.528,365.473 	"
    />

    {/* Yellow Two*/}
    <polygon 
        fill="rgb(250,166,26)" 
        points="655.779,298.921 655.779,275.4 642.933,250.744 608.099,230.634 436.5,209.563 86.8,185.109 76.176,203.256 76.191,266.87 642.933,298.921 655.779,298.921"
    />
    {/*Yellow One*/}
    <path 
        fill="rgb(255,212,0)" 
        d="M86.8,185.109l349.7,24.454l171.599,21.07l34.834,20.11v14.885	l-32.949-2.015c-15.296-19.147-38.673-31.618-64.992-32.077c-23.848-0.417-45.626,9.109-61.377,24.737 c-26.416-13.027-57.537-16.255-83.049-17.921l-147.315-9.01c-18.387-1.125-5.965,30.828-22.414,18.791 c-13.847-10.339-30.924-16.596-49.456-16.92c-29.853-0.521-56.474,14.475-72.155,37.523l-33.049-1.869v-63.613L86.8,185.109 L86.8,185.109z"
    />
    {/*Yellow One Front Bumper*/}   
    <polygon 
        fill="rgb(255,203,5)" 
        points="655.779,275.399 642.933,250.744 608.099,230.634 642.933,285.278 642.933,298.921 655.779,298.921 655.779,275.399"
    />
    {/*Yellow Rocker F Background*/}
    <polygon 
        fill="rgb(255,212,0)" 
        points="543.528,372.699 642.933,372.699 642.933,396 543.528,396 543.528,372.699"
    />
    {/*Yellow Rocker F*/}
    <polygon 
        fill="rgb(250,166,26)" 
        points="543.528,379.3 642.933,379.3 642.933,396 543.528,396 543.528,379.3"
    />
    {/*Yellow Rocker Front Background*/}
    <polygon 
        fill="rgb(255,203,5)" 
        points="642.933,372.699 655.779,372.699 655.779,396 642.933,396 642.933,372.699"
    />
    {/*Yellow Rocker Front*/}
    <polygon 
        fill="rgb(247,148,30)" 
        points="642.933,379.3 655.779,379.3 655.779,396 642.933,396 642.933,379.3"
    />
    {/*Door Handle Highlight*/}
    <path 
        fill="rgb(255,242,0)" 
        d="M302.899,232.38c-0.903-1.849-2.974-4.587-8.14-6.69 c-9.912-4.039-26.723-4.895-28.843-5.051c-2.937-0.219-9.122-0.149-8.186,5.914l0.478,3.094L302.899,232.38L302.899,232.38z"
    />
    {/*Door Handle Shadow*/}
    <path 
        fill="rgb(243,112,33)" 
        d="M266.162,231.082c1.954,0,3.548,1.594,3.548,3.548	s-1.594,3.548-3.548,3.548c-1.953,0-3.547-1.594-3.547-3.548S264.209,231.082,266.162,231.082L266.162,231.082z M300.152,232.212 l-29.457-1.802c0.471,5.016,2.687,6.109,4.926,6.132l20.105,1.186C300.893,237.779,300.152,232.212,300.152,232.212 L300.152,232.212z"
    />
    {/*Yellow One Highlight*/}
    <polygon 
        fill="rgb(255,242,0)" 
        points="436.5,209.563 86.8,185.109 76.176,203.256 77.452,203.257 436.5,209.563"
    />
    {/*BS Base*/}
    <polygon 
        fill="rgb(0,38,97)" 
        points="76.176,230.965 650.943,266.119 655.779,275.4 655.779,298.921 642.933,298.921 76.176,266.869 76.176,230.965"
    />
    {/*Front Wheel Shadow*/}
    <path 
        fill="rgb(0,15,71)" 
        d="M483.985,255.907l126.007,7.707 c7.921,9.916,13.668,21.623,16.538,34.379l-163.414-9.241C467.483,276.212,474.703,265.007,483.985,255.907L483.985,255.907z"
    />
    {/*Blue Stripe HL1*/}
    <path 
        fill="rgb(2,63,136)" 
        d="M642.933,265.629v33.292l-16.402-0.928 c-2.87-12.756-8.617-24.463-16.538-34.379L642.933,265.629L642.933,265.629z"
    />
    {/*Blue Stripe HL2*/}
    <path 
        fill="rgb(3,78,162)" 
        d="M216.679,239.559l24.987,1.527 c-1.477,7.1-1.863,13.611-10.83,7.049C226.426,244.842,221.688,241.963,216.679,239.559L216.679,239.559z"
    />
    {/*Blue Stripe HL3*/}
    <path 
        fill="rgb(2,63,136)" 
        d="M76.176,230.965v35.904l33.049,1.868 c10.422-15.317,25.676-27.077,43.501-33.091L76.176,230.965L76.176,230.965z"
    />
    {/*Mirror Body Shadow*/}
    <path 
        fill="rgb(253,185,19)" 
        d="M420.018,215.521l1.227,1.87 c-8.865-0.307-14.482,2.165-16.687,3.683c-2.327,1.602-2.546,5.234,3.085,4.68l25.139-2.47c1.26,0.041,2.572-0.003,3.807-0.202 c1.378-0.223,4.542-1.097,3.238-3.086l-2.383-3.635c-1.073,0.17-2.324,0.216-3.747,0.117 C429.137,216.16,424.577,215.84,420.018,215.521L420.018,215.521z"
    />
    {/*Mirror Background*/}
    <path 
        fill="rgb(245,195,0)" 
        d="M437.443,216.361c4.697-0.74,6.028-3.823,3.786-7.244l-3.907-5.96 c-0.822-1.253-3.626-4.647-5.669-6.215c-6.813-5.228-12.349-6.552-21.103-6.552c-4.264,0-5.566,0.952-7.2,4.458 c-0.749,1.604-1.124,3.95-1.124,5.72v5.09c0,1.447,0.091,3.408,1.29,4.729l2.525,2.78c0.802,0.882,2.007,1.519,3.195,1.601 l10.78,0.754L423.61,221c0.935,1.426,3.336,1.578,4.617,1.802c2.035,0.354,5.423,0.755,8.36,0.28	c1.378-0.223,4.542-1.097,3.238-3.086L437.443,216.361L437.443,216.361z"
    />
    {/*Mirror Base*/}
    <path 
        fill="rgb(235,135,25)" 
        d="M437.443,216.361c-1.073,0.17-2.324,0.217-3.747,0.117	l-13.679-0.957L423.61,221c0.935,1.426,3.336,1.578,4.617,1.802c2.035,0.354,5.423,0.755,8.36,0.28	c1.378-0.223,4.542-1.097,3.238-3.086L437.443,216.361L437.443,216.361z"
    />
    {/*Mirror_Base_Highlight*/}
    <path 
        fill="rgb(245,175,0)" 
        d="M438.299,219.592l-1.062-1.619
		c-0.336-0.513-1.093-0.805-1.733-0.85l-14.267-0.997l0.845,1.288l7.073,0.523c2.369,0.174,3.686,0.219,5.114,2.258
		c0.733,1.045,2.132,1.713,3.148,1.344C438.434,221.169,438.88,220.408,438.299,219.592L438.299,219.592z"
    />
    {/*"Mirror_Shadow"*/}
    <path 
        fill="rgb(240,155,15)" 
        d="M437.443,216.361c-1.073,0.17-2.324,0.217-3.747,0.117	l-24.459-1.711c-1.188-0.082-2.394-0.719-3.195-1.601l-2.525-2.78c-0.374-0.412-0.64-0.886-0.829-1.388	c6.532,0.457,33.813,2.364,38.542,0.118C443.472,212.538,442.141,215.621,437.443,216.361L437.443,216.361z"
    />
    {/*"Mirror_Highlight"*/}
    <path 
        fill="rgb(255,245,0)" 
        d="M402.947,203.555c10.225,2.229,20.418-6.53,32.119-2.197 c-1.167-1.412-2.479-2.742-3.855-3.847c-3.146-2.373-6.389-4.21-10.196-5.287c-3.183-0.815-6.384-1.06-9.66-1.109	c-3.919-0.018-5.603,0.411-7.351,4.036c-0.744,1.691-1.035,3.584-1.057,5.423V203.555L402.947,203.555z"
    />

    
{/*Canon Livery*/}

    {/*Honda Logo*/}
    <path 
        fill="rgb(255,255,255)" 
        fillRule="evenodd"
        clipRule="evenodd"
        d="M269.844,262.085l-0.145,2.367l2.419,0.148l-0.161,2.635 l-10.297-0.63l0.161-2.635l2.245,0.137l0.454-7.417l-2.245-0.138l0.161-2.638l10.297,0.629l-0.161,2.639l-2.42-0.147l-0.145,2.357	l7.576,0.464l0.145-2.358l-2.42-0.147l0.162-2.639l10.297,0.63l-0.162,2.638l-2.245-0.137l-0.453,7.417l2.245,0.138l-0.161,2.636 l-10.297-0.63l0.161-2.636l2.42,0.148l0.145-2.367L269.844,262.085L269.844,262.085z M367.537,260.343l-11.014-0.674l-0.161,2.639 l2.998,0.184l-4.735,7.155l-2.48-0.151l-0.161,2.635l8.508,0.521l0.161-2.635l-2.291-0.141l1.061-1.458l6.666,0.408l0.665,1.563
		l-2.313-0.142l-0.161,2.635l11.158,0.683l0.161-2.635l-2.513-0.154L367.537,260.343L367.537,260.343z M363.002,262.865l1.655,3.32 l-3.703-0.227L363.002,262.865L363.002,262.865z M331.847,260.808l2.632,0.161l-0.453,7.418l-2.632-0.161l-0.161,2.636 l13.368,0.817c4.172,0.255,7.263-1.189,7.556-5.984c0.245-4.006-2.773-6.462-6.508-6.69l-13.641-0.834L331.847,260.808	L331.847,260.808z M339.455,268.719l0.453-7.417l2.92,0.178c1.914,0.117,3.74,1.114,3.579,3.753 c-0.161,2.64-1.344,3.829-3.292,3.71L339.455,268.719L339.455,268.719z M307.143,269.388l8.141,0.498l0.161-2.636l-2.571-0.157	l0.418-6.829l6.656,9.907l7.691,0.471l0.614-10.054l2.464,0.151l0.161-2.639l-8.239-0.504l-0.162,2.639l2.521,0.153l-0.395,6.438
		l-6.512-9.508l-10.174-0.622l-0.161,2.639l2.5,0.152l-0.454,7.418l-2.5-0.153L307.143,269.388L307.143,269.388z M296.152,266.384 c2.175,0.133,4.232-1.4,4.377-3.764s-1.711-4.136-3.885-4.269c-2.175-0.133-4.233,1.399-4.378,3.763 C292.122,264.479,293.979,266.251,296.152,266.384L296.152,266.384z M295.986,269.091c4.271,0.47,10.002-0.683,10.334-6.116 c0.332-5.435-5.215-7.276-9.511-7.33c-4.271-0.471-10.001,0.682-10.334,6.116C286.144,267.194,291.691,269.036,295.986,269.091 L295.986,269.091z"
    />
    {/*Mobil Blue*/}
    <path 
        fill="rgb(50,71,148)" 
        fillRule="evenodd"
        clipRule="evenodd"
        d="M387.295,345.595h3.182l1.813,6.188l1.856-6.188h3.05v9.885 h-2.033v-6.879l-2.033,6.879h-1.856l-1.9-6.924v6.939h-2.077V345.595L387.295,345.595z M418.17,345.599h2.034v9.885h-2.034V345.599	L418.17,345.599z M414.738,348.157h2.033v7.347h-2.033V348.157L414.738,348.157z M416.79,347.628v-2.072h-2.071v2.072H416.79 L416.79,347.628z M406.288,345.595h2.033v3.198c0.557-0.387,1.22-0.611,1.933-0.611c1.962,0,3.552,1.7,3.552,3.798
		s-1.59,3.798-3.552,3.798c-0.713,0-1.376-0.226-1.933-0.612v0.314h-2.033V345.595L406.288,345.595z M410.008,353.679 c0.929,0,1.682-0.753,1.682-1.682s-0.753-1.681-1.682-1.681c-0.928,0-1.681,0.752-1.681,1.681S409.08,353.679,410.008,353.679 L410.008,353.679z"
    />
    {/*Mobil Red*/}
    <path 
        fill="rgb(215,25,32)" 
        fillRule="evenodd"
        clipRule="evenodd"
        d="M398.021,351.951c0-2.098,1.7-3.798,3.798-3.798 s3.798,1.7,3.798,3.798s-1.7,3.798-3.798,3.798S398.021,354.049,398.021,351.951L398.021,351.951z M401.813,353.623 c0.929,0,1.682-0.753,1.682-1.682s-0.753-1.682-1.682-1.682s-1.682,0.753-1.682,1.682S400.885,353.623,401.813,353.623
		L401.813,353.623z"
    />
    {/*Mobil Black*/}
    <path 
        fill="rgb(0,0,0)" 
        fillRule="evenodd"
        clipRule="evenodd"
        d="M433.317,355.503v-9.923h-9.923v9.923H433.317L433.317,355.503z M427.895,346.354 h1.636v8.266h-1.813v-6.453h-1.238v-1.193C426.479,346.973,427.613,347.192,427.895,346.354L427.895,346.354z"
    />
    {/*Panel Back*/}
    <path 
        fill="rgb(0,0,0)" 
        d="M418.683,230.271h31.067c1.666-0.002,3.217,1.01,3.876,2.543v0.004c0.215,0.502,0.334,1.051,0.334,1.623v39.228 c0.001,2.32-1.944,4.167-4.21,4.168l-31.066,0.001c-2.307-0.001-4.207-1.892-4.207-4.171v-39.226 C414.475,232.121,416.421,230.272,418.683,230.271L418.683,230.271z"
    />
    {/*Panel*/}
    <path 
        fill="rgb(255,255,255)" 
        d="M449.75,232.271h-31.067c-1.183,0-2.207,0.949-2.206,2.17v39.226c0,1.197,1,2.171,2.207,2.171l31.066-0.001 c1.184,0,2.21-0.951,2.21-2.168v-39.228C451.96,233.225,450.928,232.271,449.75,232.271L449.75,232.271z"
    />
    {/*Panel Shadow*/}
    <path 
        fill="rgb(230,230,230)" 
        d="M451.96,253.949l-35.483-2.17v-12.172	c11.458,1.099,23.539,2.762,35.483,5.594V253.949L451.96,253.949z"
    />
    {/*5*/}
    <path 
        fill="rgb(0,0,0)" 
        d="M445.272,237.864v6.501h-12.061l-0.631,4.09c0.653-0.148,1.307-0.26,1.967-0.326 c0.661-0.074,1.307-0.111,1.944-0.111c3.229,0,5.782,0.965,7.652,2.901c1.87,1.938,2.806,4.564,2.806,7.883 c0,3.54-1.165,6.33-3.488,8.371c-2.33,2.041-5.515,3.065-9.56,3.065c-1.922,0-3.726-0.215-5.389-0.653	c-1.669-0.438-3.132-1.068-4.394-1.893l0.564-7.696l0.676,0.134c0.779,1.173,1.825,2.093,3.132,2.769 c1.306,0.675,2.709,1.009,4.216,1.009c2.019,0,3.577-0.482,4.675-1.447c1.106-0.965,1.655-2.322,1.655-4.074 c0-1.678-0.593-3.058-1.781-4.127c-1.188-1.076-2.738-1.61-4.631-1.61c-1.276,0-2.435,0.215-3.458,0.639	c-1.032,0.43-1.96,1.076-2.784,1.952l-1.068-0.632l2.635-16.743H445.272L445.272,237.864z"
    />
    {/*S2R*/}
    <path 
        fill="rgb(65,65,65)" 
        fillRule="evenodd"
        clipRule="evenodd"
        d="M424.831,365.473h4.695l-6.983,7.228h-4.695L424.831,365.473 L424.831,365.473z M431.893,365.473h4.694l-6.982,7.228h-4.698L431.893,365.473L431.893,365.473z M438.953,365.473h4.695 l-6.982,7.228h-4.697L438.953,365.473L438.953,365.473z M446.014,365.473h4.696l-6.983,7.228h-4.696L446.014,365.473	L446.014,365.473z M417.769,365.473h4.697l-4.74,4.904v-4.858L417.769,365.473L417.769,365.473z M376.729,369.969h2.368
		c0.313,0,0.453,0.186,0.453,0.363v0.268c0,0.178-0.14,0.363-0.453,0.363l-9.196,0.006v1.731h10.066	c1.166,0,1.712-0.724,1.712-1.737v-0.994c0-1.013-0.546-1.736-1.712-1.736h-3.623h-3.71c-0.313,0-0.452-0.186-0.452-0.363v-0.268 c0-0.178,0.14-0.363,0.452-0.363h8.917v-1.736h-9.786c-1.165,0-1.712,0.723-1.712,1.736v0.994c0,1.013,0.547,1.736,1.712,1.736	H376.729L376.729,369.969z M395.385,368.72h2.918v1.004h-2.918V368.72L395.385,368.72z M388.84,367.232l2.854,0.006	c0.313,0,0.452,0.186,0.452,0.363v0.268c0,0.178-0.14,0.363-0.452,0.363h-2.37h-4.964c-1.165,0-1.711,0.724-1.711,1.736	c0,0.91,0,1.82,0,2.731l11.626-0.008v-1.735l-9.045,0.006c-0.313,0-0.452-0.186-0.452-0.363v-0.268	c0-0.178,0.139-0.363,0.452-0.363h3.709h3.624c1.165,0,1.712-0.724,1.712-1.736v-0.994c0-1.014-0.547-1.736-1.712-1.736h-4.656 l-3.49-0.002c-1.165,0-1.712,0.724-1.712,1.736v0.364l2.13-0.001c0-0.178,0.139-0.363,0.451-0.363L388.84,367.232L388.84,367.232z M402.077,368.725v-1.486h7.352c0.409,0,0.744,0.334,0.744,0.743l0,0c0,0.409-0.335,0.743-0.744,0.743H402.077L402.077,368.725z M399.63,365.502c0,0,9.814,0,10.963,0c1.149,0,2.245,0.245,2.245,2.471s-1.919,2.226-2.32,2.226l3.596,2.502h-4.163l-3.414-2.502 h-4.459v2.502h-2.447V365.502L399.63,365.502z"
    />
    {/*Canon*/}
    <path 
        fill="rgb(190,0,0)" 
        fillRule="evenodd"
        clipRule="evenodd"
        d="M313.281,292.413l-15.529,8.272l8.563-12.623 c-2.249-1.515-4.777-2.372-7.92-2.517c-8.402-0.372-15.551,6.009-15.889,14.499c-0.401,8.457,6.171,15.546,14.598,15.914	c5.486,0.239,10.432-2.438,13.314-6.671l0.615,2.26c-3.926,4.753-11.088,8.28-20.328,7.869c-15.178-0.668-23.014-10.239-22.582-20 c0.422-9.791,9.467-18.537,24.237-17.896C302.717,281.973,309.172,286.094,313.281,292.413L313.281,292.413z M380.229,322.372
		l-11.138-0.486l0.968-22.157c0.066-1.527-1.12-2.834-2.646-2.9c-1.54-0.067-2.836,1.131-2.903,2.658l-0.958,22.158l-11.103-0.485 l1.09-24.938l-7.407-0.322l10.89-4.601c0.745-0.25,1.479-0.412,2.312-0.375c2.774,0.12,4.984,2.256,5.28,4.929l9.029-3.797	c0.727-0.249,1.506-0.441,2.334-0.406c3.061,0.134,5.476,2.729,5.342,5.778L380.229,322.372L380.229,322.372z M343.332,297.063 l5.572,23.954l-11.105-0.484l-1.213-5.292c-2.428,3.17-7.158,5.616-12.836,5.356c-5.091-0.21-11.322-4.477-11.078-10.478	c0.278-5.979,6.855-9.611,11.965-9.406c3.624,0.177,6.814,1.251,9.371,3.464l-2.094-8.942l-14.413-0.629l13.253-4.259 C337.435,288.187,342.42,292.971,343.332,297.063L343.332,297.063z M329.458,316.593c3.136,0.137,5.796-2.294,5.933-5.437	c0.137-3.137-2.301-5.791-5.437-5.928c-3.144-0.138-5.81,2.294-5.946,5.431C323.87,313.802,326.314,316.455,329.458,316.593
		L329.458,316.593z M384.563,307.764c0.379-8.672,7.724-15.401,16.407-15.022c8.69,0.379,15.421,7.724,15.043,16.396	c-0.379,8.677-7.725,15.397-16.415,15.018C390.915,323.775,384.184,316.44,384.563,307.764L384.563,307.764z M403.382,321.954 c1.89-0.458,2.97-2.198,2.555-4.055l-4.634-20.452c-0.402-1.81-2.153-2.961-4.073-2.511c-1.801,0.418-2.942,2.174-2.505,4.05 l4.659,20.446C399.769,321.268,401.554,322.356,403.382,321.954L403.382,321.954z M449.615,325.414l-11.15-0.487l0.973-22.162 c0.066-1.528-1.118-2.828-2.652-2.896s-2.836,1.125-2.902,2.653l-0.961,22.163l-11.101-0.485l1.089-24.938l-7.401-0.322l10.886-4.6	c0.743-0.256,1.491-0.411,2.312-0.375c2.773,0.121,4.988,2.25,5.279,4.929l9.03-3.803c0.725-0.244,1.506-0.436,2.332-0.399 c3.074,0.134,5.49,2.723,5.357,5.772L449.615,325.414L449.615,325.414z"
    />

    {/*Goodyear*/}
    <path 
        fill="rgb(0,38,97)" 
        fillRule="evenodd"
        clipRule="evenodd"
        d="M190.516,222.112l-1.699-3.513 c-0.685,1.266-2.34,3.126-2.65,5.162c-0.877,0.6-2.039,1.275-1.407,2.389C186.728,225.81,189.063,223.404,190.516,222.112 L190.516,222.112z M185.057,226.635l0.429,0.613c4.723-1.625,5.155-4.895,10.032-6.744l-0.379-0.677	C191.229,220.877,189.249,225.22,185.057,226.635L185.057,226.635z M196.269,212.799c-0.304,0.4-0.636,0.475-1.142,0.35 c-0.482,0.252-0.945,0.176-1.439-0.135c0.477-0.157,0.909-0.363,1.118-0.725c0.597,0.176,1.062,0.205,1.284-0.389 c0.449,0.308,0.916,0.289,1.393,0.132C197.313,212.535,196.923,212.792,196.269,212.799L196.269,212.799z M194.063,215.279 c-0.27-0.157-0.489-0.404-0.807-0.563c0.021-0.326,0.043-0.698-0.126-0.988c0.312,0.252,0.678,0.368,1.095,0.44 C194.107,214.534,194.039,214.903,194.063,215.279L194.063,215.279z M198.644,214.438c-0.026-0.328-0.344-0.487-0.614-0.645 c0.662-0.146,1.273-0.201,1.424-0.379c0.049-0.044-0.078-0.238-0.387-0.538l3.398,0.161c1.209,0.074,2.766-0.951,2.881-2.064 c-0.336,0.166-0.909,0.364-1.377,0.383l-7.158-0.531c-1.248-0.217-2.652-0.162-3.376,0.214c-1.118,0.726-1.099,1.94-0.987,3.161 c-0.222,1.34,0.01,2.896,0.802,3.691c0.493-0.437,0.894-0.879,1.079-1.615c0.125,0.241,0.35,0.395,0.623,0.506 c0.215-0.455,0.24-0.873,0.269-1.338c0.128,0.194,0.303,0.392,0.577,0.502c0.271-0.637,0.352-1.193,0.387-1.751 C196.995,214.664,197.923,214.768,198.644,214.438L198.644,214.438z M182.583,216.678l-1.425,4.209 c-0.174,0.551-0.481,0.998-1.229,0.998l-0.697-0.042l2.116-6.361l0.931,0.058C182.605,215.559,182.809,216.038,182.583,216.678	L182.583,216.678z M183.205,214.147l-5.629-0.345l-2.945,9.206l5.443,0.333c4.051,0.201,5.651-2.315,6.227-4.849 C186.83,215.957,185.289,214.415,183.205,214.147L183.205,214.147z M217.076,222.29l1.639-2.375l0.081,2.48L217.076,222.29	L217.076,222.29z M219.12,216.344l-6.248,9.004l2.001,0.123l1.027-1.524l3.023,0.185l0.137,1.596l4.232,0.259l-0.545-9.419 L219.12,216.344L219.12,216.344z M231.945,218.903c-0.093,0.741-0.322,1.428-0.551,2.114c-0.162,0.363-0.236,0.825-0.888,0.785 l-0.558-0.034l0.963-3.536l0.697,0.043C231.938,218.249,232.104,218.586,231.945,218.903L231.945,218.903z M233.635,217.232
		l-6.514-0.398l-3.177,9.191l4.466,0.273l1.234-3.381l0.674,3.497l4.373,0.267l-0.711-3.639c1.348-0.664,1.904-1.377,2.28-2.941 C236.639,217.742,234.795,217.35,233.635,217.232L233.635,217.232z M204.791,215.468l-2.795,2.958l-0.647-3.168l-4.606-0.282	l1.264,5.308l-1.277,4.077l4.467,0.273l1.123-3.854l4.752-5.172L204.791,215.468L204.791,215.468z M210.148,221.025l2.14,0.131 l0.576-1.786l-2.187-0.134l0.523-1.695l3.35,0.205l0.521-1.649l-7.582-0.464l-2.853,9.211l7.536,0.461l0.626-1.83l-3.349-0.204 L210.148,221.025L210.148,221.025z M191.66,214.852l-2.236,1.451l2.367,0.238C191.658,216.045,191.629,215.359,191.66,214.852	L191.66,214.852z M191.629,216.904l-2.461-0.244c0.118,0.533-0.042,1.209-0.244,1.713L191.629,216.904L191.629,216.904z M194.888,219.345l-0.662-1.394c-0.299,0.308-0.694,0.657-1.036,0.916c-0.456-0.516-0.975-1.021-1.156-1.705l-2.752,1.467 l1.531,3.221C191.817,220.91,193.777,219.696,194.888,219.345L194.888,219.345z M191.691,214.34l0.001-1.541l-0.163-0.384 l-3.245,1.903c0.151,0.569,0.487,1.197,0.686,1.77L191.691,214.34L191.691,214.34z M149.148,218.975	c-0.113,0.32-0.369,0.679-0.878,0.601c-0.653,0.007-0.62-0.551-0.554-0.874l1.428-4.256c0.171-0.503,0.522-0.901,1.357-0.804 c0.604,0.037,1.004,0.388,1.396,0.833l1.057-1.244c-0.844-0.705-1.805-1.043-2.918-1.158c-3.678-0.178-5.766,1.889-6.402,3.904	c-0.768,1.867-0.305,4.977,2.943,5.316l5.769,0.354l1.618-5.085l-4-0.245L149.148,218.975L149.148,218.975z M160.982,215.59	c-0.41,1.376-0.871,2.795-1.375,4.166c-0.174,0.549-0.586,1.178-1.186,1.047c-0.459-0.12-0.414-0.865-0.24-1.414
		c0.324-1.475,0.834-2.938,1.341-4.354c0.368-0.679,0.544-1.274,1.146-1.19C161.5,213.987,161.109,215.037,160.982,215.59 L160.982,215.59z M160.371,212.611c-2.557-0.203-4.955,1.611-5.679,4.275s0.812,5.047,3.746,5.179	c2.89,0.083,5.284-0.892,6.152-4.387C165.433,214.602,163.02,212.819,160.371,212.611L160.371,212.611z M171.59,216.239	c-0.411,1.375-0.825,2.798-1.376,4.165c-0.173,0.549-0.585,1.178-1.138,1.051c-0.46-0.121-0.414-0.865-0.334-1.42 c0.37-1.473,0.881-2.936,1.434-4.35c0.275-0.684,0.545-1.274,1.146-1.19C172.107,214.637,171.717,215.687,171.59,216.239
		L171.59,216.239z M170.979,213.26c-2.51-0.2-4.955,1.611-5.633,4.277c-0.77,2.662,0.813,5.047,3.699,5.178 c2.938,0.085,5.238-0.895,6.152-4.387C176.039,215.25,173.674,213.471,170.979,213.26L170.979,213.26z"
    />
    

{/*Wing*/}    

    {/*Black*/}
    
    {/*Yellow*/}
    
    {/*Black*/}


    

		</svg>
		</div>

	);//return
}